import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Disclaimer from '@/pages/Disclaimer.vue';
import List from '@/pages/List.vue';
import Report from '@/pages/Report.vue';
import NotFound from '@/pages/NotFound.vue';
import Login from '@/pages/Login.vue';
import store from '@/store';
import Dish from '@/pages/Dish.vue';
import ExposureLog from '@/pages/ExposureLog.vue';
import Profile from '@/pages/Profile.vue';
import Home from '@/pages/Home.vue';

const routes: Array<RouteRecordRaw> = [
  { path: '/login', name: 'Login', component: Login, meta: { requiresGuest: true }  },
  { path: '/', redirect: '/home' },
  { path: '/report', name: 'Report', component: Report, meta: { requiresAuth: true } },
  { path: '/list', name: 'List', component: List, meta: { requiresAuth: true } },
  { path: '/profile', name: 'Profile', component: Profile, meta: { requiresAuth: true } },
  { path: '/home', name: 'Home', component: Home, meta: { requiresAuth: true } },
  {
    path: '/dish/:dish_id',
    name: 'Dish',
    component: Dish,
    meta: { requiresAuth: true },
  },

  {
    path: '/dish/:dish_id/log/:log_id',
    name: 'ExposureLog',
    component: ExposureLog,
    meta: { requiresAuth: true }
  },

  { path: '/disclaimer', name: 'Disclaimer', component: Disclaimer },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }, // Catch-all 404
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresGuest = to.matched.some(record => record.meta.requiresGuest);
  const auth = getAuth();
  const user = await getCurrentUser();

  // Refresh token on route change if user is authenticated
  if (user) {
    try {
      await store.dispatch('refreshIdToken');
    } catch (error) {
      console.error('Token refresh failed:', error);
      // If token refresh fails, clear auth and redirect to login
      await store.dispatch('signOut');
      next('/login');
      return;
    }
  }

  if (requiresAuth && !user) {
    next('/login'); // Redirect to login if not authenticated
  } else if (requiresGuest && user) {
    next('/'); // Redirect to home if logged in and trying to access login
  } else {
    next(); // Proceed to the route
  }
});

function getCurrentUser() {
  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(
      getAuth(),
      (user) => {
        removeListener();
        resolve(user);
      },
      reject
    )
  })
}

export default router;
